import { DifficultyLevel } from '../../../shared/enums';

type Difficulty = {
  level: DifficultyLevel;
  totalLevels: number;
  groupMovements: number;
  groupSizeRange: [number, number];
  groupAppearanceFrequency: number;
  groupExitTime: number;
  offsetAnswer: number;
  time: number;
};

export const difficultyConfig: Difficulty[] = [
  {
    level: DifficultyLevel.VERY_EASY,
    totalLevels: 2,
    groupMovements: 3,
    groupSizeRange: [2, 3],
    groupAppearanceFrequency: 3,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 20,
  },
  {
    level: DifficultyLevel.EASY,
    totalLevels: 2,
    groupMovements: 3,
    groupSizeRange: [3, 4],
    groupAppearanceFrequency: 3,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 20,
  },
  {
    level: DifficultyLevel.MEDIUM,
    totalLevels: 2,
    groupMovements: 4,
    groupSizeRange: [3, 5],
    groupAppearanceFrequency: 2.8,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 20,
  },
  {
    level: DifficultyLevel.HARD,
    totalLevels: 2,
    groupMovements: 4,
    groupSizeRange: [3, 5],
    groupAppearanceFrequency: 2.4,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 20,
  },
  {
    level: DifficultyLevel.VERY_HARD,
    totalLevels: 3,
    groupMovements: 4,
    groupSizeRange: [2, 5],
    groupAppearanceFrequency: 2.4,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 24,
  },
  {
    level: DifficultyLevel.PRO,
    totalLevels: 3,
    groupMovements: 4,
    groupSizeRange: [2, 5],
    groupAppearanceFrequency: 2.2,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 24,
  },
  {
    level: DifficultyLevel.MASTER,
    totalLevels: 3,
    groupMovements: 5,
    groupSizeRange: [2, 5],
    groupAppearanceFrequency: 2.2,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 24,
  },
  {
    level: DifficultyLevel.EXPERT,
    totalLevels: 3,
    groupMovements: 5,
    groupSizeRange: [2, 5],
    groupAppearanceFrequency: 2,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 24,
  },
  {
    level: DifficultyLevel.GENIUS,
    totalLevels: 4,
    groupMovements: 5,
    groupSizeRange: [3, 6],
    groupAppearanceFrequency: 2,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 28,
  },
  {
    level: DifficultyLevel.LEGEND,
    totalLevels: 4,
    groupMovements: 5,
    groupSizeRange: [3, 6],
    groupAppearanceFrequency: 1.8,
    groupExitTime: 2.5,
    offsetAnswer: 4,
    time: 28,
  },
];

export function getConfigByDifficulty(difficulty: DifficultyLevel) {
  return difficultyConfig.find((config) => config.level === difficulty) || difficultyConfig[0];
}
